module.exports = "<div class=\"bottom-controls\" *ngIf=\"show\">\n    <div class=\"container\">\n        <button class=\"btn btn-primary\" (click)=\"onSave()\">Save</button>\n        <button class=\"btn btn-outline-primary\" (click)=\"onCancel()\">Cancel</button>\n        <span>{{message}}</span>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/bottom-toolbar/bottom-toolbar.component.html
// module id = ./src/app/components/bottom-toolbar/bottom-toolbar.component.html
// module chunks = main